import { OT_ALERT_BOX_CLOSED_COOKIE_NAME, OT_CONSENT_COOKIE_NAME } from './constants';

export function getCookie(name) {
  const found = document.cookie.split(';').find((cookie) => {
    const trimmed = cookie.trimStart();
    const eqIndex = trimmed.indexOf('=');
    return eqIndex !== -1 && trimmed.slice(0, eqIndex) === name;
  });
  if (!found) return null;
  const trimmed = found.trimStart();
  return decodeURIComponent(trimmed.slice(trimmed.indexOf('=') + 1));
}

export function getGroupsConsent() {
  const otAlertBoxClosedCookie = getCookie(OT_ALERT_BOX_CLOSED_COOKIE_NAME);
  const otConsentCookie = getCookie(OT_CONSENT_COOKIE_NAME);
  if (otAlertBoxClosedCookie) {
    const groupsMatch = otConsentCookie && otConsentCookie.match(/groups=([^&]*)/);
    const groups = groupsMatch && groupsMatch[1].split(',');
    if (groups) {
      return groups.reduce((activeGroups, group) => {
        const [groupNo, consent] = group.split(':');
        return consent === '1' ? activeGroups.concat(groupNo) : activeGroups;
      }, []);
    }
  }
  return undefined;
}

export function isGroupConsentGiven(group) {
  const groupsConsent = getGroupsConsent();
  return groupsConsent && groupsConsent.includes(String(group));
}
